import { config } from './config/slider';

$('#overlayModal').on('shown.bs.modal', () => {
     const initializedCls = '.slick-initialized';

     $('.slider.overlay-slider.slider-watch').not(initializedCls).slick({ ...config, variableWidth: false });
     $('.slider.overlay-slider.slider-read').not(initializedCls).slick({ ...config, variableWidth: false });
     $('.slider.overlay-slider.slider-podcast').not(initializedCls).slick({ ...config, variableWidth: false });
});
